import { Typography, Divider, Row, Col } from "antd";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { ContentWrapper } from "../../common/styledComponents";
import ActionLogDrawerAsync from "../../common/ActionLogDrawerAsync";
import UserFilters from "../Mandanten/Common/UserFilters";
import { CommandForm } from "./CommandForm";
import { HeaderRow, AuditLogButton } from "./styledComponents";
import { useFilteredUser } from "@/lib/hooks/useFilteredUser";

const { Title, Text } = Typography;

const getTexts = (t: TFunction<"CommandHub">) => ({
  title: t("title"),
  noUserSelected: t("noUserSelected"),
  commandHistory: t("commandHistory"),
  viewAuditLogs: t("viewAuditLogs"),
});

export const CommandHubView = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);
  const { user, filterOptions, setFilterOptions } = useFilteredUser();

  return (
    <ContentWrapper>
      <Row>
        <Col flex="auto">
          <UserFilters
            withoutLoadAll
            filterOptions={filterOptions}
            setFilterOptions={setFilterOptions}
          />
        </Col>
      </Row>
      <div className="mt-4">
        <HeaderRow>
          <Title level={3}>{texts.title}</Title>
          <ActionLogDrawerAsync
            title={texts.commandHistory}
            modelName="AdminCommand"
            recordIds={user ? [user.id.toString()] : []}
            selectedFields={["__command"]}
            renderButton={({ onClick }) => (
              <AuditLogButton type="link" onClick={onClick}>
                {texts.viewAuditLogs}
              </AuditLogButton>
            )}
          />
        </HeaderRow>

        <div className="mt-2">
          {user ? (
            <>
              <Divider />
              <CommandForm user={user} />
            </>
          ) : (
            <Text>{texts.noUserSelected}</Text>
          )}
        </div>
      </div>
    </ContentWrapper>
  );
};
